<template>
  <div class="home" v-loading.fullscreen.lock="fullscreenLoading">
    <h1>خوش آمدید!</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home'
}
</script>
